<template>
  <div>
    <div class="search">
      <!-- <div class="search-input">
                <el-input v-model="searchName"  placeholder="物业项目">
                    <el-button slot="append" icon="el-icon-search" @click="searchKeyWord"></el-button>
                </el-input>
            </div> -->
    </div>
    <!-- 通知公告响应率 -->
    <el-table
      @cell-click="cellClick"
      :data="tableData"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="数据正在加载中，请稍候"
    >
      <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
      <template slot="empty">
        <span v-if="loading"></span>
        <span v-else>暂无数据</span>
      </template>
      <el-table-column
        :formatter="formatter"
        align="center"
        prop="EaAreaName"
        label="物业项目"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        :formatter="formatter"
        align="center"
        prop="Name"
        label="企业人员"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Job"
        label="职务"
        min-width="150"
        :formatter="formatter"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="ReceiveNoticeTotalCount"
        label="接收消息数"
        min-width="150"
        :formatter="formatter"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="ViewedNoticeInTimeCount"
        label="查看消息数"
        min-width="150"
        :formatter="formatter"
      >
        <template slot-scope="scope">
          {{ scope.row.ViewedNoticeInTimeCount || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="查看率（%）" align="center" width="120">
        <template slot-scope="scope">{{
          scope.row.ViewedNoticeInTimeCount
            | getProbability(scope.row.ReceiveNoticeTotalCount)
        }}</template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div class="page">
        <of-page :page="page" @getData="getTableDataByType()"></of-page>
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
export default {
  name: 'noticeList',
  props: {
    code: String,
    eaAreaCode: String,
    columnLabel: String,
    objType: Number || String,
  },
  components: {},
  data() {
    return {
      loading: false,
      searchName: '',
      tableData: [],
      page: new Page(),
    };
  },
  filters: {
    getProbability(num1, num2) {
      if (num1 == 0 || num2 == 0) {
        return 0;
      } else {
        return ((Number(num1) / Number(num2)) * 100).toFixed(2) + '%';
      }
    },
  },
  mounted() {
    this.CreditInformationController = new CreditInformationController();
    this.getTableData();
  },
  methods: {
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    cellClick(row, column) {
      this.$router.push({
        name: 'comprehensiveDetailsList',
        query: {
          objType: this.objType,
          columnLabel: encodeURIComponent(this.columnLabel),
          eaAreaCode: row.EaAreaCode || row.eaAreaCode || '',
          nickName: encodeURIComponent(row.NickName || row.nickName || ''),
        },
      });
    },
    // 搜索
    searchKeyWord() {},
    // 翻页
    getTableDataByType() {
      this.getTableData();
    },
    //获取列表数据orgCode:String, endTime:Date, startIndex:int, maxSize:int
    getTableData() {
      this.loading = true;
      this.CreditInformationController.GetCreditInfoOfPersonNoticeList(
        this.code,
        '',
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then((res) => {
          this.loading = false;
          if (res && res._Items) {
            this.tableData = res._Items;
            this.page.getCurrtNum = res.TotalCount;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: error,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  padding: 15px 0;
  display: flex;
  align-items: center;
  .search-input {
    flex: 1;
    display: flex;
    .el-input {
      .el-input__inner {
        background-color: rgb(140, 78, 127);
      }
    }
  }
}
.footer {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
  .fun {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
    .delete {
      margin-left: 20px;
    }
  }
}
</style>
